import { palettes, SmallBody, Status } from '@indigo-ag/component-module';
import React from 'react';
import { usePhase1Menu } from './context/Phase1MenuContext';
import styled from 'styled-components';
import { ListItem } from './context/Phase1.types';
import { orderBy } from 'lodash';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import { getCheckStatusVariant } from '../BrazilGrowerFinance/utils/backgroundCheck.util';

const Item = styled.div`
  margin-left: 0;
  max-width: 8.125rem;
  margin-bottom: 0.625rem;
`;

const ItemTitle = styled.p<{ selected?: boolean }>`
  font-size: 0.875rem;
  font-weight: 700;
  color: ${({ selected }) => (selected ? palettes.brand.blue.base : palettes.brand.gray['800'])};
  cursor: pointer;
  &:hover {
    color: ${palettes.brand.gray['600']};
  }
`;

const SubItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.625rem;
`;

interface Phase1SubmenuProps {
  items: ListItem[];
}

export const Phase1Submenu = ({ items }: Phase1SubmenuProps) => {
  const { setSelectedItem, selectedItem } = usePhase1Menu();

  return (
    <>
      {items.map(({ id, title, submenuItems, type }) => (
        <Item key={id}>
          <ItemTitle onClick={() => setSelectedItem(type)} selected={type === selectedItem}>
            {title}
          </ItemTitle>
          {orderBy(submenuItems, ['title'], ['asc']).map(item => (
            <SubItem key={item.key}>
              <Status label="" variant={getCheckStatusVariant(item.status) as FeedbackVariants} role="div" />
              <SmallBody style={{ marginLeft: 10, maxWidth: 130 }}>{item.text}</SmallBody>
            </SubItem>
          ))}
        </Item>
      ))}
    </>
  );
};
